var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CampaignDetail',{attrs:{"title":"View Campaign","campaignKey":_vm.campaignKey,"employer":_vm.employer}})}
var staticRenderFns = []

export { render, staticRenderFns }